export const apiTags = {
    TENANTS: 'Tenants',
    VEHICLE: 'Vehicle',
    VEHICLES: 'Vehicles',
    VEHICLES_TYPES: 'VehiclesTypes',
    MARKETS: 'Markets',
    LOTS: 'Lots',
    LOT_ATTACHMENTS: 'LotAttachments',
    LOT_MAP: 'LotMap',
    LOT_MAP_URL: 'LotMapUrl',
    LOT_PHOTOS: 'LotPhotos',
    LOT_SUMMARY: 'LotSummary',
    LOT_SCORES: 'LotScores',
    LOT_SCHEDULE: 'LotSchedule',
    CLIENT_CONFIG: 'ClientConfig',
    CLIENT_CHECKIN: 'ClientCheckIn',
    READINESS_CONFIG: 'ReadinessConfig',
    READINESS: 'Readiness',
    CLIENT_LOT_CONFIG: 'ClientLotConfig',
    CLIENT: 'Client',
    LOAD_INVOICES: 'LoadInvoices',
    STORAGE_INVOICES: 'StorageInvoices',
    STORAGE_REPORT: 'StorageReport',
    BILLING_REPORT: 'BillingReport',
    STEP_DEFINITION: 'StepDefinition',
    STEP_DEFINITION_DETAILS: 'StepDefinitionDetails',
    CLIENT_VALUES: 'ClientValues',
    INSPECTION: 'Inspection',
    USER_LOT: 'UserLotRelations',
    LOADS: 'Loads',
    LOAD_GROUP: 'LoadGroup',
    LOT_AUDIT: 'LotAudit',
    ONE_ON_ONE: 'OneOnOne',
    ISSUES_TRACKER: 'IssuesTracker',
    MECHANICALS_CONFIG: 'MechanicalsConfig',
    ACTIVITIES: 'activities',
    MECHANICAL_ACTIVITIES: 'mechanical_activities',
    ACTIVITY_LOG: 'activityLog',
    ACTIVITY_LOG_MATERIALS: 'activityLogMaterials',
    CONDITION_REPORT: "ConditionReport",
    ACTIVITY_INVOICES: 'activityInvoices',
    NOTES: 'notes',
    MECHANICAL_RULE_TYPES: 'mechanicalRuleTypes',
    ACTIVITY_TYPES: 'activityTypes',
    ACTIVITY_TYPE_PRICE: 'activityTypePrice',
    BUNDLE: 'Bundle',
    ACTIVITY_ITEM_MATERIAL: 'ActivityItemMaterial',
    VENDOR: 'vendor',
    USER_CLAIMS: 'userClaims',
    INVENTORY: 'Inventory',
    UNIT_MEASURE: 'UnitMeasure',
    ACCESS: 'Access',
    CONFIGURATION: 'configuration',
    ACTIVITY_TYPE_INVENTORY: 'ActivityTypeInventory',
    ACTIVITY_TYPE_STEP: 'ActivityTypeStep',
    USERS: 'Users',
    USER_MANAGER: 'UserManager',
    PERMISSION: 'Permission',
    USER_ROLE: 'UserRole',
    ROLE: 'Role',
    USER_PERMISSIONS: 'UserPermissions',
    MECHANICAL_TASK: 'MechanicalTask',
    MECHANICAL_WORK: 'MechanicalWork',
    USER_TASK: 'userTask',
    USER_TASK_BY_USER_ID: 'userTaskByUserId',
    USER_TASK_BY_ID: 'userTaskById',
    USER_TASK_CONFIG: 'userTaskConfig',
    AUDIT: 'Audit',
    USER_PREFERENCES: 'UserPreferences',
    SECURITY_PHOTOS: 'SecurityPhotos',
    FORM_BUILDER: 'FormBuilder',
    CUSTOM_REPORT: 'CustomReport',
    CUSTOM_FORM_RESPONSE: 'CustomFormResponse',
    CONTACT_TYPE: 'ContactType',
    CLIENT_ACCOUNTS: 'ClientAccounts',
    FLAGS: 'Flags',
    ATTACHMENTS: 'Attachments',
    VEHICLE_STATUS: 'VehicleStatus',
    ACTIVITY_STATUS_ALIAS: 'ActivityStatusAlias',
    DOOR_RELEASES: 'DoorReleases',
    COST_CODES: 'CostCodes',
    TAX_RATE: 'TaxRate',
    RESERVATION: 'Reservation',
    CARRIER: 'Carrier',
    QB_MAPPING: 'QBMapping',
    ME: 'Me',
    ISSUE_TRACKER_RULE: 'IssueTrackerRule',
    SUBSCRIPTIONS: 'subscriptions',
    CLIENT_SUBSCRIPTIONS: 'clientSubscriptions',
    EMAIL_TYPES: 'emailTypes',
    VENDOR_FEEDBACK: 'vendorFeedback',
    VENDOR_CONTACT: 'vendorContact',
    VMS: 'vms',
    SLA_CYCLE_DEFINITION: 'SlaCycleDefinition',
    SLA_COMPLIANCE: 'SlaCompliance',
    VENDOR_INVOICES: 'VendorInvoices',
    VENDOR_INVOICE_FILES: 'VendorInvoiceFiles',
    LOAD_PRICING_CONFIG: 'LoadPricingConfig',
    VENDOR_DETACHED_TEMPLATE: 'VendorDetachedTemplate',
    ACTIVITY_ITEM: 'ActivityItem',
}